// The admin app's page paths. On the admin server it owns the root
// (admin.overlayhq.com/sign-in); on a developer machine it lives under /admin,
// because the root there is the public app. The page shell says which
// (window.__ADMIN_BASE__, from App\Support\ServerRole::adminBase()).
//
// Inside the admin app's router these are handled by its `basename`; use this
// only for full page loads and raw history writes.

export const adminBase = () => (typeof window !== 'undefined' && window.__ADMIN_BASE__ != null
  ? window.__ADMIN_BASE__
  : '/admin');

/** adminPath('/sign-in') → '/sign-in' or '/admin/sign-in'; adminPath() → '/' or '/admin'. */
export const adminPath = (path = '') => `${adminBase()}${path}` || '/';
